import React from 'react';
import Environment from '../environment/environment.js';
import BaseMixin from '../common/base-mixin.js';
import ElementaryMixin from '../common/elementary-mixin.js';
import NestingLevelMixin from '../common/nesting-level-mixin.js';
import ContentMixin from '../common/content-mixin.js';
import Span from './span.js';
import {Div} from './factory.js';

import './lsi-item.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Lsi.Item',
    nestingLevelList: Environment.getNestingLevelList('spa'),
    classNames: {
      main: 'uu5-bricks-lsi-item'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    language: React.PropTypes.string.isRequired
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      language: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    let children = (this.getNestingLevel() === 'inline')
        ? (<Span {...this.getMainPropsToPass()} content={this.props.content}>
        {this.props.children && React.Children.toArray(this.props.children)}
      </Span>)
      : (<Div {...this.getMainPropsToPass()} content={this.props.content}>
      {this.props.children && React.Children.toArray(this.props.children)}
    </Div>);
    return children;
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/lsi-item.js